/**
 * @file 认证流程
 * @author wangzhuang
 */
import React from 'react';
import {connect} from 'react-redux';
import {withRouter, Prompt} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Form, FormItem, Upload, Checkbox, Spin, Toast, Modal, Tips} from '@baidu/spui';
import Steps from './steps';
import Xmod from './xmod';
import Viewmod from './viewmod';
import './index.less';
import {fetchAuth, fetchSendCode, fetchCheckphone, fetchRegion} from '../../actions/attestAction';
import {initCaptcha} from '../../../src/constants/utils';

// import {location} from './location';
import demo from '../../asset/img/单位号码证明函模板.docx';
import {checkNumber} from '../../../src/components/util';
import CommonModal from '../../components/commonModal.tsx';

// const cascaderOptionData = [];

// for (let attr in location[0]) {
//     let children = [];
//     for (let attr2 in location[`0,${attr}`]) {
//         children.push({
//             value: `${location[0][attr]},${location[`0,${attr}`][attr2]}`,
//             name: location[`0,${attr}`][attr2]
//         });
//     }

//     cascaderOptionData.push({
//         value: location[0][attr],
//         name: location[0][attr],
//         children: children
//     });
// }

class AttestStep extends React.Component {
    constructor(prop) {
        super(prop);
        this.state = {
            myStep: this.props.match.params.num - 1,
            attestType: '2',
            name: '1',
            checkboxValue2: false,
            magnifyOff: false,
            logoId: false,
            spinOff: false,
            icpId: false,
            promptOff: true,
            trademarkId: false, // 商标
            magnifySrc: '',
            formData: {},
            formData2: {
                display: '',
                phone: '',
                name: '', // 企业名称
                province: '', // 省份
                district: '',
                town: '',
                city: '', // 城市
                address: '', // 详细地址
                industry: '', // 行业分类
                companyQualifyId: false, // 企业资质
                companyQperatorId: false, // 运营商证明
                certOtherId: false, // 其他证明
                certOther2Id: false, // d单位证明函
                email: '', // 邮箱
                code: '', // 邮箱验证码
                tel: '', // 手机
                tel_code: '', // 手机验证码
                website: '', // 网址
                icpId: false, // icp
            },
            logoError: '',
            icpError: '',
            companyQualifyError: '', // 企业资质报错
            companyQperatorError: '', // 运营商证明报错
            certOtherError: '',
            certOther2Error: '', // 单位证明函报错
            trademarkError: '',
            modTop: 290,
            codeOff: false,
            codeTime: 60,
            telTime: 60,
            codeOff1: false,
            Iscommit: false,
            phoneArr: [{key: Date.now()}],
            isSubmitModal: false,
            provinceOption: [],
            cityOption: [],
            districtOption: [],
            townOption: []
        };
    }

    componentDidMount() {

        let {num, type} = this.props.match.params;
        this.getRegionData('province');

        if (num === '2' && !type) {
            this.props.history.push('/attest/step/1');
        }
        window.scrollTo(0, 0);

        this.scrollFn();
        window.addEventListener('scroll', this.scrollFn);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            promptOff: nextProps.match.params.num !== '3'
        });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', null);
    }

    scrollFn = () => {
        let scrollTop = document.documentElement.scrollTop;
        if (scrollTop > 150) {
            this.setState({
                modTop: 110
            });
        } else {
            this.setState({
                modTop: 270 - scrollTop
            });
        }
    };
    handleRegionOption = (regionData) => {
        const tempRegionData = regionData.map(item => {
            item.label = item.name_short;
            return item;
        });
        return [...tempRegionData];
    };
    getRegionData = (type, code) => {
        let param = '';
        if (type === 'city') {
            param = `?province_code=${code}`;
        } else if (type === 'district') {
            param = `?city_code=${code}`;
        } else if (type === 'town') {
            param = `?district_code=${code}`;
        }

        this.props.fetchRegion(param).then(data => {
            if (data && data.code === 200) {
                if (type === 'province') {
                    this.setState({
                        provinceOption: this.handleRegionOption(data.data.province),
                        cityOption: [],
                        districtOption: [],
                        townOption: []
                    });
                } else if (type === 'city') {
                    this.setState({
                        cityOption: this.handleRegionOption(data.data.city),
                        districtOption: [],
                        townOption: []
                    });
                } else if (type === 'district') {
                    this.setState({
                        districtOption: this.handleRegionOption(data.data.district),
                        townOption: []
                    });
                } else if (type === 'town') {
                    this.setState({
                        townOption: this.handleRegionOption(data.data.town)
                    });
                }
            } else {
                Modal.confirm({
                    title: '提示',
                    buttonReverse: true,
                    maskClosable: true,
                    buttonType: 0,
                    singleButton: true,
                    warningType: true,
                    okText: '好的',
                    className: 'spui-modal-other',
                    children: <div>
                        {data.message}
                    </div>,
                    onCancel: () => {},
                    onOk: () => {}
                });
            }
        });
    };

    formItemGetValue = ({name, value}) => {
        this.setState({
            formData: {
                ...this.state.formData,
                [name]: value
            }
        });
    };

    formItemGetValue2 = ({name, value}) => {
        this.setState({
            formData2: {
                ...this.state.formData2,
                [name]: value
            }
        });
        this.checked(name, value);
    };
    formItemGetArea = ({name, value}) => {
        if (name === 'province') {
            this.getRegionData('city', value.code);
            this.checked(name, value.label);
            // 修改省时需要置空市、区、街道
            this.setState({
                formData2: {
                    ...this.state.formData2,
                    province: value,
                    city: '',
                    district: '',
                    town: '',
                },
            });
        } else if (name === 'city') {
            this.getRegionData('district', value.code);

            // 修改市时需要置空区、街道
            this.setState({
                formData2: {
                    ...this.state.formData2,
                    city: value,
                    district: '',
                    town: ''
                }
            });
        } else if (name === 'district') {
            this.getRegionData('town', value.code);

            // 修改区时需要置空街道
            this.setState({
                formData2: {
                    ...this.state.formData2,
                    district: value,
                    town: ''
                }
            });
        } else if (name === 'town') {
            this.setState({
                formData2: {
                    ...this.state.formData2,
                    town: value
                }
            });
        }
    };
    onChange = ({name, value}) => {
        this.setState({[name]: value});
    };

    checkName = obj => {
        let value = obj.value;
        let v = value.replace(/(^\s*)|(\s*$)/g, '');

        if (v.length > 0 && v.length < 12) {
            this.props.fetchCheckphone({
                type: 3,
                display: value
            }).then(data => {
                if (data.code !== 200) {
                    Modal.confirm({
                        title: '展示名称已被认证',
                        buttonReverse: true,
                        maskClosable: true,
                        buttonType: 0,
                        singleButton: true,
                        warningType: true,
                        okText: '好的',
                        className: 'spui-modal-other',
                        children: <div>
                            {data.message}
                        </div>
                    });

                } else {
                    this.setState({
                        nameOff: true
                    });
                }
            });
        }
    };

    sendCodeCaptcha = () => {
        initCaptcha((tk) => {
            this.setState({
                codeOff1: true
            });
            this.sendCodeFn(tk);
        });
    };

    sendCodeFn = (tk) => {
        let formData2 = this.state.formData2;
        let tcode = 'telTime';
        let offt = 'codeOff1';

        window.BCat_2055 && window.BCat_2055.miao();
        window['__abbaidu_2055_cb'] = responseData => {
            window['___abbaidu_2055_cb'] = null;
            let localData = JSON.parse(responseData);
            this.props.fetchSendCode({
                type: 2,
                data: localData.data,
                'key_id': localData['key_id'],
                sign: localData.sign,
                svcp_stk: tk || '',
                verity: formData2.tel
            }).then(data => {
                if (data.code === 200) {
                    let timer = setInterval(() => {
                        let codeTime = this.state[tcode];
                        if (codeTime > 1) {
                            this.setState({
                                [tcode]: codeTime - 1
                            });
                        } else {
                            clearInterval(timer);
                            this.setState({
                                [tcode]: 60,
                                [offt]: false
                            });
                        }
                    }, 1000);
                } else {
                    this.setState({
                        [tcode]: 60,
                        [offt]: false
                    });
                    Toast.display({
                        type: 'error',
                        info: data.message,
                        delay: 3500
                    });
                }

            });
        };
    };
    checked = (n, value) => {
        let {
            phone,
            // name, // 企业名称
            // province, // 省份
            // address, // 详细地址
            // industry, // 行业分类
            // companyQualifyId, // 企业资质
            // companyQperatorId, // 运营商证明
            certOther2Id, // 单位证明函
            // email, // 邮箱
            // code, // 验证码
            tel, // 手机
            tel_code, // 手机验证码
            display, // 展示名称
            province, // 省
            // website,
            // icpId
        } = this.state.formData2;
        // let flag = false;
        let checkboxValue2 = this.state.checkboxValue2;
        // let checkp = {
        //     phone, name, industry, companyQualifyId, companyQperatorId,
        //     certOther2Id, email, code, tel, tel_code, display, checkboxValue2,
        //     website, icpId

        // };
        let checkp = {
            phone,
            certOther2Id, tel, tel_code, display, checkboxValue2, province
        };
        checkp[n] = value;
        // if (checkp.website || checkp.icpId) {
        //     flag = false;
        // } else {
        //     flag = true;
        // }
        for (let prop in checkp) {
            // if (flag && (prop === 'icpId' || prop === 'website')) {
            //     continue;
            // }
            if (!checkp[prop]) {
                this.setState({
                    Iscommit: false
                });
                return;
            }
        }
        this.setState({
            Iscommit: true
        });

    };

    submit = async vlidate => {
        const {
            // phone,
            // name, // 企业名称
            // province, // 省份
            // address, // 详细地址
            // industry, // 行业分类
            // companyQualifyId, // 企业资质
            // companyQperatorId, // 运营商证明
            // certOtherId, // 其他证明
            certOther2Id, // 单位证明函
            // email, // 邮箱
            // code, // 验证码
            // tel, // 手机
            // tel_code, // 手机验证码
            // display, // 展示名称
            // website, // 网址
            // icpId // icp
        } = this.state.formData2;

        // if (!companyQualifyId) {
        //     return this.setState({
        //         companyQualifyError: '请上传单位合法资质'
        //     });
        // } else {
        //     this.setState({
        //         companyQualifyError: false
        //     });
        // }
        if (!certOther2Id) {
            return this.setState({
                certOther2Error: '请上传单位证明函'
            });
        } else {
            this.setState({
                certOther2Error: false
            });
        }
        if (vlidate) {
            this.setState({
                isSubmitModal: true,
            });

        }
    };
    handleModalSubmit = async () => {
        const {
            phone,
            // name, // 企业名称
            province, // 省份
            address, // 详细地址
            district, // 区
            town, // 镇
            city, // 市
            // industry, // 行业分类
            // companyQualifyId, // 企业资质
            // companyQperatorId, // 运营商证明
            // certOtherId, // 其他证明
            certOther2Id, // 单位证明函
            // email, // 邮箱
            // code, // 验证码
            tel, // 手机
            tel_code, // 手机验证码
            display, // 展示名称
            // website, // 网址
            // icpId, // icp
            email // 官方邮箱
        } = this.state.formData2;
        window.BCat_2055 && window.BCat_2055.miao();
        window['__abbaidu_2055_cb'] = responseData => {
            let localData = JSON.parse(responseData);
            const region = {
                province: province.name_short,
                city: city.name_short,
                district: district.name_short,
                town: town.name_short,
            };
            let json = {
                step: 2, // 步骤
                type: 2, // 认证类型
                data: localData.data,
                'key_id': localData['key_id'],
                sign: localData.sign,
                // name,
                // email,
                // code,
                display, // 展示名称
                phone, // 电话
                tel,
                tel_code,
                region: JSON.stringify(region),
                address,
                // province: province.split(',')[0],
                // city: province.split(',')[1],
                // 'company_qualify_id': [companyQualifyId],
                // 'company_operator_id': [companyQperatorId],
                // 'industry': industry.label,
                'cert_other_2': [certOther2Id],
                'is_read': 1,
                email: email
            };
            this.setState({spinOff: true});
            this.props.fetchAuth(json).then(data => {
                this.setState({spinOff: false, isSubmitModal: false});
                if (data.code === 200) {
                    this.setState({promptOff: false}, () => {
                        this.props.history.push('/attest/step/2');
                    });
                } else {
                    Toast.display({
                        type: 'error',
                        info: data.message,
                        delay: 3500
                    });
                }
            });
        };
    };
    handleModalCancel = () => {
        this.setState({isSubmitModal: false});
    };
    render() {
        let {num} = this.props.match.params;
        let urlStr = '/api/v1/image/get?product_id=haoma&img_id=';
        let {
            spinOff, promptOff,
            formData, formData2, codeOff1, telTime,
            checkboxValue2, Iscommit,
            modTop, magnifyOff, magnifySrc, certOther2Error,
            provinceOption, cityOption, townOption, districtOption,
        } = this.state;
        // let reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
        let reg1 = /^1[3456789]\d{9}$/;
        // let reg2 = /^(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&amp;:/~+#]*[\w\-@?^=%&amp;/~+#])?$/;

        let phoneData = [];
        for (let attr in formData) {
            if (attr.indexOf('phone') !== -1) {
                phoneData.push(formData[attr]);
            }
        }
        return (
            <div className={'attest'}>
                {num === '1'
                    ? <div>
                        <div className={'mod2'}>
                            <div className="top-title">政府/非盈利机构 号码免费认证</div>
                            <div>
                                <Steps current={num}/>
                            </div>
                            <div className={'mod2-from'}>
                                <Form submit={this.submit} ref={el => (this.myFrom = el)} className={'width-960'}>
                                    <FormItem
                                        type="input"
                                        value={formData2.display}
                                        spellCheck={false}
                                        name={'display'}
                                        horizontal={true}
                                        rules={
                                            [
                                                {
                                                    validate(value) {
                                                        let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                        return v.length === 0;
                                                    },
                                                    message: '此项不能为空！'
                                                }
                                            ]
                                        }
                                        label={<span><i className={'star'}>*</i>展示名称</span>}
                                        placeHolder={'请输入展示名称'}
                                        getValue={this.formItemGetValue2}
                                    />
                                    <FormItem
                                        type="input"
                                        value={formData2.phone}
                                        name={'phone'}
                                        horizontal={true}
                                        label={<span><i className={'star'}>*</i>认证号码</span>}
                                        placeHolder={'请输入座机、手机、400/800、95/96、1010号码(仅限一个)'}
                                        onBlur={obj => {
                                            let value = obj.value;

                                            if (
                                                checkNumber(value)
                                            ) {
                                                this.props.fetchCheckphone({
                                                    type: 2,
                                                    phone: value
                                                }).then(data => {
                                                    if (data.code !== 200) {
                                                        Modal.confirm({
                                                            title: '提示',
                                                            buttonReverse: true,
                                                            maskClosable: true,
                                                            buttonType: 0,
                                                            singleButton: true,
                                                            warningType: true,
                                                            okText: '好的',
                                                            className: 'spui-modal-other',
                                                            children: <div>
                                                                {data.message}
                                                            </div>,
                                                            onCancel: () => {},
                                                            onOk: () => {}
                                                        });
                                                    } else {
                                                        this.setState({});
                                                    }
                                                });
                                            }
                                        }}
                                        rules={
                                            [
                                                {
                                                    validate(value) {
                                                        let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                        return v.length === 0;
                                                    },
                                                    message: '此项不能为空！'
                                                },
                                                {
                                                    validate(value) {
                                                        return !checkNumber(value);
                                                    },
                                                    message: <span>
                                                        <span>号码格式有误，支持座机/手机、400/800、95/96、1010号码！</span>
                                                        <span style={{display: 'block'}}>
                                                            如有疑问，请添加QQ群725854778，私信管理员处理。
                                                        </span>
                                                    </span>
                                                },
                                                {
                                                    validate(value) {
                                                        // phoneData
                                                        let numVal = 0;

                                                        phoneData.forEach(item => {
                                                            if (item === value) {
                                                                numVal++;
                                                            }
                                                        });

                                                        return numVal > 1;

                                                    },
                                                    message: '认证号码不能重复！'
                                                }
                                            ]
                                        }
                                        getValue={this.formItemGetValue2}
                                    />
                                    <div className="area-wrapper">
                                        <div className="item-wrapper">
                                            <FormItem
                                                value={formData2.province}
                                                type="select"
                                                width={100}
                                                name="province"
                                                className="area-item"
                                                label={<span><i className={'star'}>*</i>所在区域</span>}
                                                placeHolder={'省'}
                                                cancelIcon
                                                optionData={provinceOption}
                                                getValue={this.formItemGetArea}
                                                rules={
                                                    [
                                                        {
                                                            validate(value) {
                                                                return !value || (!value.label);
                                                            },
                                                            message: '此项不能为空！'
                                                        }
                                                    ]
                                                }
                                            />
                                            <FormItem
                                                value={formData2.city}
                                                type="select"
                                                width={120}
                                                name="city"
                                                className="area-item"
                                                placeHolder={'市'}
                                                cancelIcon
                                                optionData={cityOption}
                                                getValue={this.formItemGetArea}
                                            />
                                            <FormItem
                                                value={formData2.district}
                                                type="select"
                                                width={120}
                                                name="district"
                                                className="area-item"
                                                placeHolder={'区县'}
                                                cancelIcon
                                                optionData={districtOption}
                                                getValue={this.formItemGetArea}
                                            />
                                            <FormItem
                                                value={formData2.town}
                                                type="select"
                                                width={120}
                                                name="town"
                                                className="area-item"
                                                placeHolder={'街道乡镇'}
                                                cancelIcon
                                                optionData={townOption}
                                                getValue={this.formItemGetArea}
                                            />
                                        </div>
                                    </div>
                                    <FormItem
                                        type="input"
                                        value={formData2.address}
                                        spellCheck={false}
                                        name={'address'}
                                        horizontal={true}
                                        rules={
                                            [{
                                                validate(value) {
                                                    let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                    return v.length === 0;
                                                },
                                                message: '此项不能为空！'
                                            }]
                                        }
                                        label={<span><i className={'star'}>*</i>详细地址</span>}
                                        placeHolder={'请输入单位的详细地址'}
                                        getValue={this.formItemGetValue2}
                                    />
                                    <div
                                        className={'from-mod mt30 pb24'}
                                        style={certOther2Error ? {height: '223px'} : {height: '200px'}}>
                                        <div className={'from-mod-left'}>
                                            <i className={'star'}>*</i><span>单位证明函</span>
                                        </div>
                                        <div className={'from-mod-right pr'}>
                                            <Upload
                                                fileId={'feui-certOther2Id'}
                                                uploadType={'image-upload'}
                                                noWarning={true}
                                                name={'image'}
                                                width={'96px'}
                                                height={'96px'}
                                                onHandleChange={data => {
                                                    let file = data.value;
                                                    if (file.type.substr(-3) !== 'png'
                                                        && data.value.type.substr(-4) !== 'jpeg') {
                                                        this.setState({
                                                            certOther2Error: '格式不正确'
                                                        });
                                                        return false;
                                                    }
                                                    if (file.size > (1024 * 1024 * 10)) { // 1M
                                                        Toast.display({
                                                            type: 'error',
                                                            info: '图片大小过大',
                                                            delay: 3500
                                                        });
                                                        return false;
                                                    }

                                                    this.setState({
                                                        certOther2Error: ''
                                                    });

                                                    file.formDatas.append('product_id', 'haoma');
                                                    file.formDatas.append('is_spot', 'NO');

                                                    let myInit = {
                                                        method: 'POST',
                                                        credentials: 'include',
                                                        body: file.formDatas
                                                    };

                                                    fetch('/api/v1/image', myInit)
                                                        .then(response => response.json())
                                                        .then(response => {
                                                            if (response.code === 200) {
                                                                formData2.certOther2Id = response.data.id;
                                                                this.setState({
                                                                    formData2: formData2
                                                                });
                                                                this.checked(
                                                                    'certOther2Id', response.data.id
                                                                );
                                                            } else {
                                                                Toast.display({
                                                                    type: 'error',
                                                                    info: response.message,
                                                                    delay: 3500
                                                                });

                                                            }
                                                        });
                                                }}
                                            />
                                            {formData2.certOther2Id
                                                ? <div
                                                    className={'load-mod'}
                                                    style={{
                                                        backgroundImage: `url(${urlStr + formData2.certOther2Id})`
                                                    }}
                                                    onClick={() => {
                                                        this.setState({
                                                            magnifySrc: `${urlStr + formData2.certOther2Id}`,
                                                            magnifyOff: true
                                                        });
                                                    }}
                                                >
                                                    <div
                                                        className={'close'}
                                                        onClick={e => {
                                                            formData2.certOther2Id = false;
                                                            this.setState({
                                                                formData2: formData2
                                                            });
                                                            this.checked('certOther2Id', false);
                                                            e.stopPropagation();
                                                        }}
                                                    />
                                                </div>
                                                : null
                                            }
                                            {
                                                certOther2Error
                                                    ? <div style={{
                                                        position: 'relative',
                                                        top: '5px'
                                                    }}
                                                    className="spui2-form-warning">
                                                        <i className="spui2-input-error"></i>
                                                        <span>{certOther2Error}</span>
                                                    </div>
                                                    : null
                                            }
                                            <div style={{marginTop: '16px'}}>
                                                <a
                                                    className={'down'}
                                                    href={demo}
                                                    download={'单位号码证明函模板.docx'}>模板下载
                                                </a>
                                            </div>
                                            <div
                                                className={'icon-text'}
                                            >
                                                <div>
                                                    <span>上传说明：单位证明函用于证实该企业名称合法有效</span><br/>
                                                    <span>上传要求：证明函需要盖单位鲜章,仅支持jpg或png格式，大小不超过10M</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <FormItem
                                        type="input"
                                        value={formData2.email}
                                        spellCheck={false}
                                        name={'email'}
                                        horizontal={true}
                                        label={'官方邮箱'}
                                        placeHolder={'请输入官方邮箱，邮箱将展示在卡面和落地页上'}
                                        rules={
                                            [
                                                {
                                                    validate(value) {
                                                        if (!value || value.trim() === '') {
                                                            return false;
                                                        }
                                                        const emailReg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
                                                        return !emailReg.test(value);
                                                    },
                                                    message: '邮箱格式不正确！'
                                                }
                                            ]
                                        }
                                        getValue={this.formItemGetValue2}
                                    />

                                    <div className={'form-mod2'}>
                                        <div>
                                            <FormItem
                                                type="input"
                                                value={formData2.tel}
                                                spellCheck={false}
                                                name={'tel'}
                                                horizontal={true}
                                                label={<span><i className={'star'}>*</i>联系电话</span>}
                                                placeHolder={'请输入正确的手机号码用来接收通知'}
                                                rules={
                                                    [
                                                        {
                                                            validate(value) {
                                                                let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                                return v.length === 0;
                                                            },
                                                            message: '此项不能为空！'
                                                        },
                                                        {
                                                            validate(value) {
                                                                return !reg1.test(value);
                                                            },
                                                            message: '手机格式不正确！'
                                                        }
                                                    ]
                                                }
                                                getValue={this.formItemGetValue2}
                                            />

                                            <FormItem
                                                type="input"
                                                value={formData2.tel_code}
                                                spellCheck={false}
                                                name={'tel_code'}
                                                horizontal={true}
                                                width={'120px'}
                                                label={<span><i className={'star'}>*</i>手机验证码</span>}
                                                placeHolder={'请输入验证码'}
                                                tips={!codeOff1
                                                    ? <span
                                                        className={reg1.test(formData2.tel) ? 'link' : 'disable'}
                                                        onClick={() => {
                                                            if (reg1.test(formData2.tel)) {
                                                                this.sendCodeCaptcha();
                                                            }
                                                        }}
                                                    >
                                                        获取验证码
                                                    </span>
                                                    : <span className={'disable'}>
                                                        {telTime}s后重新发送
                                                    </span>
                                                }
                                                rules={
                                                    [
                                                        {
                                                            validate(value) {
                                                                let v = value.replace(/(^\s*)|(\s*$)/g, '');
                                                                return v.length === 0;
                                                            },
                                                            message: '此项不能为空！'
                                                        }
                                                    ]
                                                }
                                                getValue={this.formItemGetValue2}
                                            />
                                            <div className={'form-check'}>
                                                <Checkbox
                                                    name="zzz2"
                                                    value="rrr2"
                                                    checked={checkboxValue2}
                                                    theme={'blue'}
                                                    getValue={e => {
                                                        this.setState({
                                                            checkboxValue2: e.checked
                                                        });
                                                        this.checked('checkboxValue2', e.checked);
                                                    }}
                                                >
                                                    <span>已阅读</span>
                                                    <a
                                                        href="https://haoma.baidu.com/privacy/agreement.html"
                                                        className={'link line'}
                                                        rel="noopener noreferrer"
                                                        target={'_blank'}>
                                                        《企业号码认证服务协议》
                                                    </a>
                                                    <span>和</span>
                                                    <a
                                                        href="https://haoma.baidu.com/privacy/index.html"
                                                        className={'link line'}
                                                        rel="noopener noreferrer"
                                                        target={'_blank'}>
                                                        《百度号码服务隐私政策》
                                                    </a>
                                                </Checkbox>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'form-btn'}>
                                        <div>
                                            <FormItem
                                                name={'f12'}
                                                className={'spui2-m-r10'}
                                                styleType={'ghost'}
                                                label={'取消'}
                                                type="button"
                                                onClick={() => {
                                                    this.setState({promptOff: true}, () => {
                                                        this.props.history.push('/attest');
                                                    });
                                                }}
                                            />
                                            {!Iscommit
                                                ? <Tips
                                                    title="输入所有必填项后可提交"
                                                    placement={'bottom-left'}
                                                    className={'leftip'}
                                                    preventOverflowEnabled={false}>
                                                    <FormItem
                                                        name={'f11'}
                                                        styleType={'modal'}
                                                        label={'提交'}
                                                        disabled={!Iscommit}
                                                        submitFlag={true}
                                                        type="button"
                                                    />
                                                </Tips>
                                                : <FormItem
                                                    name={'f11'}
                                                    styleType={'modal'}
                                                    label={'提交'}
                                                    disabled={!Iscommit}
                                                    submitFlag={true}
                                                    type="button"
                                                />

                                            }
                                        </div>

                                        {
                                            spinOff
                                                ? <div>
                                                    <Spin
                                                        type={'small'}
                                                        description={'正在检测当前数据是否正确，请稍等'}
                                                    />
                                                </div>
                                                : null
                                        }
                                    </div>
                                </Form>
                            </div>
                        </div>
                        <Viewmod
                            phone={formData2.phone}
                            name={formData2.display}
                            modTop={modTop}
                            email={formData2.email}
                        />
                    </div>
                    : null
                }
                {num === '2'
                    ? <Xmod backhandle={() => {
                        this.setState({promptOff: false}, () => {
                            this.props.history.push('/user_center/my_attest');
                        });
                    }}/>
                    : null
                }
                {
                    magnifyOff
                        ? <div
                            className={'magnify'}
                            onClick={() => {
                                this.setState({magnifyOff: false});
                            }}
                        >
                            <img
                                src={magnifySrc}
                                alt=""
                                onClick={e => {
                                    e.stopPropagation();
                                }}
                            />
                        </div>
                        : null
                }
                {num !== '2'
                && <Prompt
                    when={promptOff}
                    message={() =>
                        '是否不提交信息进行跳转？'
                    }
                />
                }
                <CommonModal
                    modalVisible={this.state.isSubmitModal}
                    handleModalSubmit={this.handleModalSubmit}
                    handleModalCancel={this.handleModalCancel}
                >
                    <div className="item-row-1">
                        您认证的的内容不包括
                        <a href="/call_auth" className="link line" target={'_blank'}>
                            来电名片显示
                        </a>，请问是否继续提交？
                    </div>
                </CommonModal>
            </div>
        );
    }
}

AttestStep.propTypes = {
    history: PropTypes.object,
    match: PropTypes.object,
    fetchAuth: PropTypes.func,
    fetchSendCode: PropTypes.func,
    fetchCheckphone: PropTypes.func,
    fetchRegion: PropTypes.func,
    userInfo: PropTypes.object
};

function mapStateToProps(state) {
    return {
        userInfo: state.userInfo
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchAuth: obj => fetchAuth(dispatch, obj),
        fetchSendCode: obj => fetchSendCode(dispatch, obj),
        fetchCheckphone: obj => fetchCheckphone(dispatch, obj),
        fetchRegion: obj => fetchRegion(dispatch, obj)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AttestStep));